module.exports = __webpack_public_path__ + "static/media/flower_screenshot_en.1e08210d.png";